'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExpandButton = require('./components/ExpandButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpandButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/expandable/lib/components/expand-button/index.js
// module id = 275
// module chunks = 1